
import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { GiveDocumentAccessRequest, GiveFormAccessRequest, GrantTypeEnum } from "../../../models/document-management.models";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { DocumentAccessApi } from "../../../apis/document-access.api";
import { GoogleAnalyticsService } from "@rightship-tech/common-ui/services/analytics/google-analytics.service";

@autoinject
@transient()
export class DialogAcceptDenyAccess {

    private _accessRequestId: number;
    public isForm: boolean = false;
    public customerName: string;
    public documentName: string;
    public vesselName: string;
    public vesselImo: string;
    public comments: string;

    constructor(public dialogClientService: DialogClientService, private documentAccessApi: DocumentAccessApi,
        private notificationClientService: NotificationClientService, private googleAnalyticsService: GoogleAnalyticsService) { }

    activate(model: { accessRequestId: number, isForm: boolean, customerName: string, documentName, vesselName, vesselImo, comments }) {
        this._accessRequestId = model.accessRequestId
        this.isForm = model.isForm
        this.customerName = model.customerName
        this.documentName = model.documentName
        this.vesselName = model.vesselName
        this.vesselImo = model.vesselImo
        this.comments = model.comments
    }

    //Approve access
    public async approveAccess() {
        this.save(GrantTypeEnum.Approve)
    }

    //Denya access
    public async denyAccess() {
        this.save(GrantTypeEnum.Reject)
    }

    //Save
    public async save(accessType: GrantTypeEnum) {
        try {
            if (this.isForm) {
                let request: GiveFormAccessRequest = {
                    formAccessRequestId: this._accessRequestId,
                    grant: accessType,
                    itemName: this.documentName,
                    vesselName: this.vesselName,
                    vesselImo: this.vesselImo
                }

                await this.documentAccessApi.giveFormAccess(request)
            }
            else {
                let request: GiveDocumentAccessRequest = {
                    documentAccessRequestId: this._accessRequestId,
                    grant: accessType,
                    itemName: this.documentName,
                    vesselName: this.vesselName,
                    vesselImo: this.vesselImo
                }

                await this.documentAccessApi.giveDocumentAccess(request)
            }

            this.notificationClientService.show(`Access ${accessType == GrantTypeEnum.Approve ? 'Granted' : 'Rejected'}`, "", NotificationType.Success);

            //Send event to google analytics
            this.googleAnalyticsService.sendCustomGA4EventMulti("dmc_view_docs_request_access_" + (accessType == GrantTypeEnum.Approve ? 'accept':'deny'), {
                "charterer": this.customerName ?? "N/a",
                "documentName": this.documentName ?? "N/a" 
            });

            //Hide dialog
            this.dialogClientService.hide(true);
        }
        catch (error) {
            console.log(error)
            this.notificationClientService.show(`An error occured when ${accessType == GrantTypeEnum.Approve ? 'granting' : 'rejecting'} access`, "", NotificationType.Error)
        }
    }

    cancel() {
        this.dialogClientService.hide();
    }
}
